export default "__VITE_ASSET__7J0mh_Qy__"